namespace GeniuzPOS.Purchase {
    export interface PoCreditNotePrintData extends Serenity.ListRequest {
        Header?: PoCreditNoteRow;
        Supdata?: Supplier.CsSupplierRow;
        Details?: PoCreditNoteDtRow[];
        SysDocNo?: string;
        Paydesc?: string;
        Para?: Administration.CsParaRow;
        URLpic?: string;
        BizName?: string;
        BizAddressLine1?: string;
        BizAddressLine2?: string;
        BizAddressLine3?: string;
        TaxId?: string;
    }
}
